<template>
<div class="autocomplete-search">
    <div :class="searchClass">
        <vue-autosuggest
            v-model="query"
            :suggestions="searchSuggestions"
            @focus="focusMe"
            @click="clickHandler"
            @input="onInputChange"
            @selected="onSelected"
            @keyup.enter="onEnter"
            :get-suggestion-value="getSuggestionValue"
            :component-attr-id-autosuggest="`autosuggest__` + searching"
            :input-props="{
                id:'autosuggest__'+searching+'__input',
                class:'form-control data-hj-allow',
                placeholder:placeholder
            }">
            <div slot-scope="{suggestion}" class="d-flex">
                <div class="d-flex">{{suggestion.item.title}}</div>
            </div>
        </vue-autosuggest>
        <input type="hidden" name="selected-id" :value="selected.id">
    </div>
</div>
</template>

<script>
    const CancelToken = axios.CancelToken;
    let cancel;
    import { VueAutosuggest } from 'vue-autosuggest';
    export default {
        components: {
            VueAutosuggest
        },
        name: "AutocompleteSearch",
        props: ['size', 'searching', 'default', 'placeholder'],
        data: function () {
            return {
                query: this.default,
                selected: false,
                searchSuggestions: [ { data: null } ],
                // placeholder: this.size === 'md' ? 'Search Pins or Pin Series' : 'Pin Search',
                emptyResponse: {
                    md: [
                        "What do you think you're doing?",
                        "I can't let you do that Dave.",
                        "The existential search for Nothing?",
                        "Whoa there, I think you forgot something.",
                        "What are you hoping to find?",
                        "There isn't a Forgetful Dwarf.",
                        "Clicking buttons willy-nilly.",
                        "P Sherman, 42 Wallaby Way, Sydney",
                    ],
                    sm: [
                        "What are you doing?",
                        "I can't let you, Dave.",
                        "Existential search?",
                        "Did you forgot me?",
                        "42 Wallaby Way",
                    ]
                }
            }
        },
        computed: {
            searchClass: function() {
                if (this.size === 'sm') {
                    return ['search-sm', 'nav-search'];
                } else if (this.size === 'md') {
                    return ['search-md'];
                } else if (this.size === 'lg') {
                    return ['search-lg'];
                }
            }
            // filteredOptions() {
            //     return [
            //         {
            //             data: this.searchSuggestions[0].data.filter(option => {
            //                 return option.name.toLowerCase().indexOf(this.query.toLowerCase()) > -1;
            //             })
            //         }
            //     ];
            // }
        },
        mounted() {
            // console.log(this.searchSuggestions);
        },
        methods: {
            onEnter: function(e) {
                if (this.query === '') {
                    window.location.href = '/pins';
                }
            },
            onInputChange: function(text) {
                // event fired when the input changes
                // console.log(text);

                // const CancelToken = axios.CancelToken;
                // let cancel;

                let q = text.trimStart().replace(/\s\s+/g, ' ');
                this.query = q;

                if (cancel !== undefined) {
                    cancel();
                    // console.log("cancelled");
                }

                if (q !== '') {
                    axios.get('/search', {
                        cancelToken: new CancelToken(function executor(c) {
                            cancel = c;
                        }),
                        params: {
                            q: q,
                            searching: this.searching
                        }
                    }).then(response => {
                        this.searchSuggestions[0].data = response.data;
                    }).catch(function (thrown) {
                        if (axios.isCancel(thrown)) {
                            // console.log('Request canceled', thrown.message);
                        } else {
                            // handle error
                        }
                    });
                } else {
                    this.searchSuggestions[0].data = null;
                }
            },
            onSelected: function(item) {
                let loadResults = null;
                if (item && item.item.id) {
                    this.selected = item.item;
                    loadResults = '/pins/' + this.selected.id;
                } else {
                    // Empty search
                    // console.log(this.query);
                    if (this.query.trim() === '') {
                        // this.placeholder = this.emptyResponse[this.size][Math.floor(Math.random() * this.emptyResponse[this.size].length)];
                        // this.query = '';
                    } else {
                        loadResults = '/pins?q=' + this.query.replaceAll(' ', '+');
                    }
                }

                if (loadResults) {
                    window.location.href = loadResults;
                }
            },
            clickHandler: function(item) {
                // event fired when clicking on the input
            },
            /**
             * This is what the <input/> value is set to when you are selecting a suggestion.
             */
            getSuggestionValue(suggestion) {
                return suggestion.item.name;
            },
            focusMe(e) {
                // FocusEvent
            }
        }
    }
</script>
